import Navs from './Navs';

export default {
  name: 'navs',
  title: 'Flikar',
  navbar: {
    component: Navs
  }
};
